import { useCallback } from "react";
import useAxios from "../axios/useAxios";

export const usePerformanceLogger = () => {
    const axiosInstance = useAxios();

    const logPerformanceEvent = useCallback((orderId = null, path, additionalData = {}) => {
        const fullUrl = window.location.href;
        axiosInstance.post('/metrics/page-performance', {
            orderId,
            performanceData : {
              ...additionalData,
              path,
              timestamp: new Date().toISOString(),
              fullUrl
            }
        });
    }, [axiosInstance]);


    const logViewComplete = useCallback((orderId, path, additionalData) => {
        logPerformanceEvent(orderId, path, additionalData);
    }, [logPerformanceEvent]);




  return {
    logViewComplete
  };
}